var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M13 21a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h3V3a1 1 0 011-1h6a1 1 0 011 1v1h3a1 1 0 011 1v6.042a1 1 0 01-2 0V6h-2a1 1 0 01-1 1H9a1 1 0 01-1-1H6v14h6a1 1 0 011 1zM10 4v1h4V4h-4zM9 9h6a1 1 0 110 2H9a1 1 0 110-2zm0 3h4a1 1 0 110 2H9a1 1 0 110-2zm8.5 8.606l-1.792 1.245a.832.832 0 01-1.272-.924l.63-2.089-1.737-1.32a.832.832 0 01.486-1.494l2.181-.046.718-2.06a.832.832 0 011.572 0l.718 2.06 2.181.046a.832.832 0 01.486 1.495l-1.738 1.32.63 2.088a.832.832 0 01-1.271.924L17.5 20.606z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function eventTypesMenu(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};